<!--
 * @Author: ZS
 * @Date: 2020-06-09 14:50:36
 * @LastEditors: ZS
 * @LastEditTime: 2020-07-07 10:20:57
 * @Description: file content
-->
<template>
  <!-- 底部栏 -->
  <div class="footer mainContent">
    <div class="mainWidth footer_info" v-if="hasInfo != 0">
      <ul class="clearfix">
        <li class="quickLinks">
          <h4 class="tit">快速链接</h4>
          <ul>
            <li v-for="(item, index) in quickLinks" :key="index"><a :href="item.href" target="_blank">{{ item.label }}</a></li>
            <!-- <li><a href="http://lib.zzuli.edu.cn/" target="_blank">图书馆</a></li>
            <li><a href="http://www.zzuli.edu.cn/xxgk/list.htm" target="_blank">信息公开</a></li>
            <li><a href="http://kys.zzuli.edu.cn/cas/login?service=http://mail.zzuli.edu.cn/coremail/cmcu_addon/sso.jsp?face=xt5" target="_blank">邮件系统</a></li> -->
          </ul>
        </li>
        <li class="contactUs">
          <h4 class="tit">联系我们</h4>
          <div class="phone">{{$store.state.webInfo.pcGuidelineWebsiteInfoMobile || "-"}}</div>
          <!-- <p>联系信息</p> -->
        </li>
        <li class="newMedia">
          <h4 class="tit">官方微博/微信</h4>
          <div class="wb">
            <div class="iconfont icon-weibo"></div>
            <p>官方微博</p>
            <img src="../../assets/images/weibo.gif" alt="">
          </div>
          <div class="wx">
            <div class="iconfont icon-weixin"></div>
            <p>官方微信</p>
            <img src="../../assets/images/weixin.gif" alt="">
          </div>
        </li>
        <li class="aPPDownload">
          <h4 class="tit">APP下载</h4>
          <img src="../../assets/images/u501.png">
          <p>即将上线<br>敬请期待</p>
          <!-- <p>扫描右边二维码<br>下载智慧校园App</p> -->
          <!-- <img src="../../assets/images/code-syb.png" alt=""> -->
        </li>
      </ul>
    </div>
    <div class="ywtbCopy">
      <div class="mainWidth">
        <span>主办：</span>郑州轻工业大学版权所有 <span>承办：</span>精华教育科技股份有限公司 <span>地址：</span>郑州市高新区科学大道136号 <a href="http://vpn.zzuli.edu.cn/" target="_blank" class="vpn-a">VPN入口</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
props:{
hasInfo:Number
},
data () {
  return {
    quickLinks: window.quickLinks || []
  }
}
}
</script>

<style scoped>
  .footer_info li.aPPDownload img {
  position: absolute;
  left: 30px;
  top: 62px;
  width: 30px;
  height: 50px;
  }
  .footer_info li.aPPDownload p {
  margin-top: 10px;
  color: #666;
  font-size: 18px;
  line-height: 24px;
  /* font-weight: 700; */
  padding-left: 60px;
  line-height: 26px;
  }
</style>


// WEBPACK FOOTER //
// src/components/common/Footer.vue